import { CONTENT_RECOMMENDATIONS_PATH_SERVICE } from 'api/services/content/paths';
import {
  LOAD_RECOMMENDATIONS_ERROR,
  LOAD_RECOMMENDATIONS_INIT,
  LOAD_RECOMMENDATIONS_SUCCESS,
} from 'containers/Vcard/actions/recommendations/constants';
import {
  getFilterList,
  selectMetadataKeyByRegion,
} from 'reducers/selectors/metadata';
import { getRecommendedContent } from 'services/api/content/recommendations';
import { getRegion } from 'utils/Region';

export const fetchVcardRecommendations = (params = {}) => async (
  dispatch,
  getState,
) => {
  dispatch({
    type: LOAD_RECOMMENDATIONS_INIT,
  });
  const filters = getFilterList(getState());
  const cv_advertising_config =
    JSON.parse(getState().metadata.cv_advertising_config || '{}')?.[getRegion()]
      ?.enable ||
    JSON.parse(getState().metadata?.cv_advertising_config || '{}')?.default
      ?.enable;
  const url = cv_advertising_config
    ? CONTENT_RECOMMENDATIONS_PATH_SERVICE
    : 'services/content/recommendations';
  try {
    const fetchApi = await getRecommendedContent({
      ...params,
      filterlist: filters,
      is_only_provider: true,
      url: url,
      hasClaroAdActive: cv_advertising_config,
    });
    dispatch({
      type: LOAD_RECOMMENDATIONS_SUCCESS,
      payload:
        fetchApi?.[(cv_advertising_config ? 'data' : 'response')]?.groups,
    });
  } catch (e) {
    dispatch({
      type: LOAD_RECOMMENDATIONS_ERROR,
      payload: e,
    });
  }
};
